export default __webpack_public_path__ + "static/media/CardBack.160826c4.png";